import { TceManagement } from 'data/usecases';
import { makeApiUrlTceManagement } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeTceManagement = (): TceManagement => {
  return new TceManagement(makeApiUrlTceManagement(), makeAxiosHttpClient());
};
